import React, { useState, useEffect } from "react";
import "./DrawerOverlay.scss";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import fire from "../../../config/firebase";
import Moment from "moment";
import { useHistory, withRouter } from "react-router-dom";

function SaveTemplate(props) {
  const history = useHistory();
  const pathArr = props.location.pathname.split('/');
  const key = pathArr[pathArr.length - 1];
  const dataKey = key;
  const dataType = props.match.path.includes("estimates")
    ? "estimates"
    : "templates";
  const isTemplate = dataType === "templates";
  const [name, setName] = useState("");
  const [originalName, setOriginalName] = useState("");
  const [estimates, setEstimates] = useState([]);
  const [template, setTemplate] = useState([]);
  const handleName = (e) => {
    setName(e);
  };
  useEffect(() => {
    const ref = fire.database().ref("estimates");
    ref.once("value").then(
      (snapshot) => {
        const estimates = snapshot.val();
        ref.off("value");
        const estimateList = [];
        for (const id in estimates) {
          estimateList.push({ id, ...estimates[id] });
        }
        setEstimates(estimateList);

        if (dataType === "estimates" && dataKey) {
          const curEstimate = estimateList.find((d) => d.id === dataKey);
          if (curEstimate) {
            setName(curEstimate.projectName);
            setOriginalName(curEstimate.projectName);
          }
        }
      },
      () => { }
    );

    const reftemplate = fire.database().ref("templates");
    reftemplate.once("value").then(
      (snapshot) => {
        const template = snapshot.val();
        reftemplate.off("value");
        const templateList = [];
        for (const id in template) {
          templateList.push({ id, ...template[id] });
        }
        setTemplate(templateList);

        if (dataType === "templates" && dataKey) {
          const curEstimate = templateList.find((d) => d.id === dataKey);
          if (curEstimate) {
            setName(curEstimate.projectName);
            setOriginalName(curEstimate.projectName);
          }
        }
      },
      () => { }
    );
  }, []);
  const handleSave = (event) => {
    if (event === "redirect") {
      if (dataType === "templates") {
        history.push(`/estimates/`);
      } else {
        history.push(`/templates/`);
      }
    } else {
      props.closeEditScreen("close");
    }
    let copy = "";
    if (dataType === "templates") {
      for (let i = 0; i < template.length; i++) {
        if (template[i]["id"] === dataKey) {
          copy = template[i];
          copy.id = null;
          if (name !== "") {
            copy.projectName = name;
          }
          copy.date = Moment(new Date()).format("DD/MM/YYYY");
          copy.timestamp = Math.floor(Date.now() / 1000);
          copy.modified = Moment(new Date()).format("h:mm a MMMM DD, YYYY");
          const estimateRef = fire.database().ref("estimates");
          estimateRef.push(copy);
          //This was removing Templates
          // const templatesRef = fire.database().ref("templates").child(dataKey);
          // templatesRef.remove();
        }
      }
    } else {
      for (let i = 0; i < estimates.length; i++) {
        if (estimates[i]["id"] === dataKey) {
          copy = estimates[i];
          copy.id = null;
          if (name !== "") {
            copy.projectName = name;
          }
          copy.date = Moment(new Date()).format("DD/MM/YYYY");
          copy.timestamp = Math.floor(Date.now() / 1000);
          copy.modified = Moment(new Date()).format("h:mm a MMMM DD, YYYY");
          const templatesRef = fire.database().ref("templates");
          templatesRef.push(copy);
          const estimateRef = fire.database().ref("estimates").child(dataKey);
          //This was removing Estimates
          //estimateRef.remove();
        }
      }
    }
  };
  return (
    <div id="SaveTemplate" className="side-item">
      <div className="title">
        <h5>
          Save As {isTemplate ? "Estimate" : "Template"}
          <div className="cross" onClick={props.onClose}>
            <CloseIcon htmlColor="rgba(8,77,79,0.5)" />
          </div>
        </h5>
      </div>
      <div className="content">
        {/*<img src={discount} alt="discount" />*/}
        <p>Are you sure you want to save as a estimates '{originalName}'?</p>
      </div>
      <div className="input-wrap">
        <div className="d_input">
          <TextField
            variant="outlined"
            type="text"
            label={`${isTemplate ? "Estimate Name" : "Template Name"}`}
            value={name}
            onChange={(e) => handleName(e.target.value)}
          />
        </div>
        <Button
          onClick={() => handleSave("close")}
          variant="contained"
          type="button"
          className="duplicate apply"
        >
          Save
        </Button>
        <Button
          variant="outlined"
          type="button"
          onClick={() => handleSave("redirect")}
          className="saveplus"
        >
          Save + Go To {isTemplate ? "Estimates" : "Templates"}
        </Button>
      </div>
    </div>
  );
}

export default withRouter(SaveTemplate);
